export default "__VITE_ASSET__92b5d814__"